import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthGuardServiceStub implements CanActivate {
    claimChecked: boolean = true;
    jwtHelperService = new JwtHelperService();

    public user = {
        UserId: 1,
        userName: 'test',
        IsImpersonated: false
    };

    isFeatureEnabled(): boolean {
        return true;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return of(true);
    }

    logOut() {
    }

    logOutToOldPortal() {
    }

    isNavigationAuthorized() {
        return of(true);
    }

    getUserInfo() {
        return {
            cuit: '2705256745',
            taxId: '27-05256745-1'
        }
    }

    hasPermission(name: string) {
        return true;
    }

    getClaim(name: string) {
        return false;
    }
}
